/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomPersonTitleSelect/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomPersonTitleSelect({
  children,
  onChange,
  value,
  disabled,
  tabIndex,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleSelect",
  maxWidth,
  marginTop,
  size = "medium"
  
}) {
let titlesValueData = fromData.useDataValue({ viewPath,
context: 'titles',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 maxWidth={maxWidth}
 disabled={disabled}
 marginTop={marginTop}
 value={value}
 onChange={onChange}
 size={size}
 data="titles"
 from={titlesValueData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Title"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
 tabIndex={tabIndex}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}